import { render, staticRenderFns } from "./query-client-sales-by-month.vue?vue&type=template&id=129a5f30&scoped=true&"
import script from "./query-client-sales-by-month.vue?vue&type=script&lang=js&"
export * from "./query-client-sales-by-month.vue?vue&type=script&lang=js&"
import style0 from "./query-client-sales-by-month.vue?vue&type=style&index=0&id=129a5f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a5f30",
  null
  
)

export default component.exports